import { Box, Button, Grid, Typography } from "@mui/material";
import Hero from "../../components/layout/Hero";
import HighlightedEvents from "../../components/utilities/HighlightedEvents";
import FeaturedEvents from "../../components/utilities/FeaturedEvents";
import { getEnvironmentVariable } from "../../global/environmentVariables";

const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

export default function HomeCatan() {
  return (
    <>
      <Hero
        sxBackground={{
          backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7)), url('${SYSTEM_IMAGES_CLOUDFRONT}/images/header.png')`,
          height: ["unset", "70vh"],
          maxHeight: ["unset", "600px"],
          minHeight: "unset",
          color: "common.white",
        }}
      >
        <img
          src={`${SYSTEM_IMAGES_CLOUDFRONT}/images/BannerLogo.png`}
          alt=""
          style={{
            maxHeight: "300px",
            maxWidth: "65%",
          }}
        />
        <Box sx={{ marginBottom: 4, pt: 2 }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button href="/play/events" variant="contained" color="primary">
                Find an Event
              </Button>
            </Grid>
            <Grid item>
              <Button
                href="/organize/events"
                variant="contained"
                color="primary"
              >
                Host an Event
              </Button>
            </Grid>
            <Grid item>
              <Button
                href="https://catan.com/"
                variant="contained"
                color="primary"
                target="_blank"
                rel="noreferrer noopener"
              >
                About CATAN
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Hero>
      <FeaturedEvents />
      <HighlightedEvents />
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/section1.jpg`}
        backgroundTint
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white",
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              About CATAN Events
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              CATAN Studio, together with our international partners, supports
              English-language organized play of CATAN. On this site, you will
              find information about our programs: the CATAN Championship
              Series, the CATAN Masters Program, and our support of the CATAN
              Community including information about conventions and other live
              events. Visit each section for more specific details about these
              programs
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            sx={{
              pt: [1, 1, 12],
            }}
          >
            <Box>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: ["center", "center", "right"],
                }}
              >
                <Grid item xs={12}>
                  <Button
                    href="https://catanevents.com/champ/"
                    variant="contained"
                    color="primary"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    CATAN Championship
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    href="https://catanevents.com/masters/"
                    variant="contained"
                    color="primary"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    CATAN Masters
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    href="https://catanevents.com/community/"
                    variant="contained"
                    color="primary"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    CATAN Community
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Hero>
    </>
  );
}
